import React, { Component } from 'react';
import { Chevron } from '@jutro/components';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import _ from 'lodash';
import {
    TranslatorContext, withIntl
} from '@jutro/locale';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { PolicyService, UserService, ContactService } from 'gw-capability-gateway';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { BreakpointTrackerContext, withBreakpoint } from '@jutro/layout';
import { JobUtil } from 'gw-portals-util-js';
import { Link as LinkComponent, Currency as CurrencyField } from 'gw-components-platform-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import CoveragesIterableComponent from '../../Components/CoveragesIterableComponent/CoveragesIterableComponent';
import CoveragesComponent from '../../Components/CoveragesComponent/CoveragesComponent';
import PolicyLiabilityComponent from '../../Components/PolicyLiabilityComponent/PolicyLiabilityComponent';
import PolicyDwellingInfo from './ho/PolicyDwellingInfo/PolicyDwellingInfo';
import PolicyFarmInfoComponent from './farm/PolicyFarmInfoComponent/PolicyFarmInfoComponent';
import PolicyVehiclesDriversInfo from './pa/PolicyVehiclesDriversInfo/PolicyVehiclesDriversInfo';
import PolicyCommercialPropertyInfoComponent from './bop/PolicyCommericalPropertyInfoComponent/PolicyCommericalPropertyInfoComponent';
import Cancellation from '../Cancellation/Cancellation';
import ChangePolicy from '../ChangePolicy/ChangePolicy';
import metadata from './Summary.metadata.json5';
import styles from './Summary.module.scss';
import messages from './Summary.messages';
import gatewayMessages from '../../gateway.messages';
import UnderlyingPolicies from './pul/UnderlyingPolicies/UnderlyingPolicies';
import {getMetadataByBreakPoint} from './../../../../utils/breakpointUtil';
import {  ModalNextProvider } from '@jutro/components';
import platformMessages from 'gw-platform-translations/platform.messages';

function getCell(items, index, property) {
    return items[property.id];
}

function getPremium(items, index, property) {
    let premium = (items.policyDisplayStatus == 'Quoting') ? '-' : items[property.id];
    return premium;
}

function transactionTypeIsViewableInXCenter(transaction) {
    return (
        transaction.type.toLowerCase() !== 'reinstatement'
        && transaction.type.toLowerCase() !== 'rewrite'
    );
}

function canUserOpenJobInXCenter(transaction) {
    return transaction.canUserView && transactionTypeIsViewableInXCenter(transaction);
}

class Summary extends Component {
    static propTypes = {
        fromAccountLanding: PropTypes.shape({
            policyDetailsData: PropTypes.shape({
                policyResponse: PropTypes.shape({
                    policyNumber: PropTypes.string
                })
            })
        }).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func
        }).isRequired,
        authHeader: PropTypes.shape({}).isRequired,
        intl: PropTypes.func.isRequired,
    };

    static contextType = TranslatorContext;

    state = {
        policyData: '',
        disableCancelLink: true,
        disableChangePolicyLink: true,
        policyTransactionData: [],
        policyTransactionStatusValues: [],
        selectedTransactionStatus: 'all',
        searchTransactionKeyword: undefined,
        canAdvanceCancellation: false,
        canAdvancePolChange: false,
        policyNamedInsureds:[],
        liabilityPremium: ''
    };

    componentDidMount = () => {
        this.hasAdvancePermission();
        this.setPolicyCoveragesDetails();
        this.getPolicyTransactions();
        this.getPolicyContacts();
    };

    componentWillReceiveProps(nextProps) {
        if(nextProps.fromAccountLanding.policyNumber !== this.props.fromAccountLanding.policyNumber){
            this.setPolicyCoveragesDetails(nextProps);
            this.getPolicyTransactions(nextProps);
        }        
    }

    setPolicyCoveragesDetails = (nextProps) => {
        const {
            fromAccountLanding: { policyDetailsData }
        } = nextProps ? nextProps : this.props;
        const policyData = _.cloneDeep(policyDetailsData.policyResponse);
        this.setState({ policyData });
    };

    getPolicyTransactions = async (nextProps) => {
        const { authHeader, fromAccountLanding } = nextProps ? nextProps : this.props;
        const policyNumber = _.get(
            fromAccountLanding,
            'policyDetailsData.policyResponse.policyNumber'
        );
        const transactionResponse = await PolicyService.getPolicyTransactionsForPolicy(
            policyNumber,
            authHeader
        );
        this.getMappedTransactionData(transactionResponse);
        const policyTransactionStatusValues = this.getPolicyTransactionStatus();
        this.setState({
            transactionResponse,
            policyTransactionStatusValues,
            selectedTransactionStatus: policyTransactionStatusValues[0].code
        });
    };

    getPolicyContacts = async(nextProps) => {
        const { authHeader, fromAccountLanding } = nextProps ? nextProps : this.props;
        const policyNumber = _.get(
            fromAccountLanding,
            'policyDetailsData.policyResponse.policyNumber'
        );
        
        ContactService.getPolicyContactSummaries(
            policyNumber,
            authHeader,
            ['PolicyPriNamedInsured','PolicyAddlNamedInsured'],
            0,
            Number.parseInt(Number.MAX_VALUE)
        ).then((response) => {
            const policyNamedInsureds = this.getResponseData(response.policyContacts);
            this.setState({policyNamedInsureds})
        });

    }
    getResponseData = (policyContacts) => {
        if (policyContacts) {
            const contactsInfo = policyContacts.map((contact) => {
                if(contact.active &&
                    contact.policyContactRoles.includes('PolicyPriNamedInsured') ||
                    contact.policyContactRoles.includes('PolicyAddlNamedInsured' )) {
                    return {
                        name: contact.displayName,
                        role: this.getRoles(contact.policyContactRoles),
                        active: contact.active
                    };
                }
            });
            return contactsInfo;
        }
        return [];
    };

    getRoles = (policyContactRoles) => {
        let role = '';
        if(policyContactRoles.includes('PolicyPriNamedInsured') ) {
            role = 'Primary Named Insured';
        } else if(policyContactRoles.includes('PolicyAddlNamedInsured' )) {
            role = 'Additional Named Insured';
        }
        return  role;

    }

    getFormattedCurrency = (premiumAmount, index) => {
        return (
            <CurrencyField
                id={`currency${index}`}
                value={premiumAmount}
                readOnly
                hideLabel
                showOptional={false}
                className={styles.currencyStyle}
            />
        );
    };

    getMappedTransactionData = (policyTransactionResponse, filter) => {
        const selectedStatus = _.get(filter, 'selectedTransactionStatus');
        const searchKeyword = _.get(filter, 'searchTransactionKeyword');
        const transactionData = _.cloneDeep(policyTransactionResponse);
        const { intl } = this.props;

        let policyTransactionData = transactionData.map((policy, index) => {
            return {
                jobNumber: policy.jobNumber,
                status: policy.status,
                displayType: policy.displayType,
                description: policy.description,
                policyDisplayStatus: policy.policyDisplayStatus,
                totalPremium: this.getFormattedCurrency(policy.totalPremium, index),
                policyEffectiveDate: intl.formatDate(new Date(policy.policyEffectiveDate), { year: 'numeric', month: 'short', day: 'numeric' }),
                canUserView: policy.canUserView,
                type: policy.type
            };
        }).sort((a, b) => {
            return new Date(b.policyEffectiveDate).getTime()
                - new Date(a.policyEffectiveDate).getTime();
        });
        if (selectedStatus && selectedStatus !== 'all') {
            policyTransactionData = _.filter(policyTransactionData, (transaction) => {
                return transaction.status === selectedStatus;
            });
        }
        if (searchKeyword) {
            policyTransactionData = this.getSearchFilterValues(
                policyTransactionData,
                searchKeyword
            );
        }
        this.setState({
            policyTransactionData
        });
    };

    hasAdvancePermission = () => {
        const { authHeader, checkPermission } = this.props;
        
        if(checkPermission('advancecancellation')){
            this.setState({ canAdvanceCancellation:true});
        } 
        if(checkPermission('advancepolchange')){
            this.setState({ canAdvancePolChange:true});
        }
        // const permissionDTO = {
        //     permission: 'advancecancellation'
        // };
        // UserService.hasUserSystemPermission(permissionDTO, authHeader).then(
        //     (canAdvanceCancellation) => {
        //         this.setState({ canAdvanceCancellation });
        //     }
        // );
    };

    getSearchFilterValues = (transactionData, keyword) => {
        const lowerCaseFilterValue = keyword.toLocaleLowerCase();
        return _.filter(transactionData, (res) => {
            return Object.keys(res).some(
                (key) => typeof res[key] === 'string'
                    && res[key].toLocaleLowerCase().includes(lowerCaseFilterValue)
            );
        });
    };

    getJobNumberLink = (item, index, property) => {        
        const { transactionResponse } = this.state;
        const hasMultipleDrafts = _.filter(transactionResponse, (transac) => {
            return (transac.type == "PolicyChange" && transac.status == "Draft")
        }).length > 1;
      
        if (canUserOpenJobInXCenter(item)) {
            if (!this.showOpenJobInXCenter(item.type)) {
                return (
                    <LinkComponent
                        href="/"
                        onClick={() => JobUtil.openJobInXCenter(item.jobNumber)}
                    >
                        {item[property.id]}
                    </LinkComponent>
                );
            }
            return (                
                <LinkComponent to={{
                    pathname: JobUtil.getJobDetailURLByJobType(item.type, item.jobNumber),
                    state: {
                        hasMultipleDrafts: hasMultipleDrafts
                    }
                } }>
                    {item[property.id]}
                </LinkComponent>
            );
        }
        return <span>{item.jobNumber}</span>;
    };

    showOpenJobInXCenter = (item) => {
        return (
            item.type !== 'Submission'
            && item.type !== 'PolicyChange'
            && item.type !== 'Cancellation'
            && item.type !== 'Renewal'
        );
    };

    onChangePolicy = async () => {
        const { policyData, transactionResponse } = this.state;
        const { fromAccountLanding, history } = this.props;
        const policyNumber = _.get(
            fromAccountLanding,
            'policyDetailsData.policyResponse.policyNumber'
        );
        const policyDisplayStatus = _.get(
            policyData,
            'latestPeriod.displayStatus'
        );
        const { lobEndorsementURL, endorsementProducts } = appConfig;
        const productCode = _.get(policyData, 'product.productCode');
        const hasMultipleDrafts = _.filter(transactionResponse, (transac) => {
            return (transac.type == "PolicyChange" && transac.status == "Draft")
        }).length > 1;

        if(hasMultipleDrafts){
            ModalNextProvider.showAlert({
                title: messages.modelError,
                message: messages.multipleDraftsError,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: messages.ok
            }).catch(_.noop);
        } else {

            if (endorsementProducts.includes(productCode)) {
                history.push(lobEndorsementURL[productCode], { policyNumber, policyDisplayStatus });
            } else {
                this.setState({ disableChangePolicyLink: false });
            }
        }
        
    };

    getJobNumber = async (policyNumber) => {
        const { authHeader } = this.props;
        const renewalVM = await PolicyService.createNewPolicyRenewalTransaction(
            [policyNumber],
            authHeader
        );
        return _.get(renewalVM, 'jobNumber');
    };

    onRenewalPolicy = async () => {
        const { fromAccountLanding, history } = this.props;
        const { lobRenewalURL } = appConfig;
        const policy = _.get(fromAccountLanding, 'policyDetailsData.policyResponse');
        const policyNumber = _.get(policy, 'policyNumber');
        const lobCode = _.get(policy, 'latestPeriod.policyLines[0].lineOfBusinessCode');
        const jobNumber = await this.getJobNumber(policyNumber);
        if (!_.isEmpty(lobRenewalURL[lobCode])) {
            history.push(lobRenewalURL[lobCode], { jobNumber });
        } else {
            JobUtil.openJobInXCenter(jobNumber);
        }
    };

    handleCancelButtonClick = async () => {
        const translator = this.context;
        this.setState({ disableCancelLink: false });
        try{
            await ModalNextProvider.showAlert({
                title: translator(messages.cancellationDocTitle),
                message: translator(messages.cancellationDocMessage),
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: translator(platformMessages.close),
            })
        } catch(err){
        }
    };

    onDoNotCancel = () => {
        this.setState({ disableCancelLink: true });
    };

    onDoNotChangePolicy = () => {
        this.setState({ disableChangePolicyLink: true });
    };

    getResponse = async () => {
        const result = await PolicyService.getPolicy();
        return result;
    };

    getHeaderSection = (title) => {
        return (isOpen) => (
            <React.Fragment>
                <Chevron isOpen={isOpen} align="right" />
                <h2 className={`${styles.title} ${styles.gwOverrideDefaultMargin}`}>{title}</h2>
            </React.Fragment>
        );
    };

    getLiabilityHeaderSection = (title, title1, title2) => {
        return (isOpen) => (
            <React.Fragment>
                <Chevron isOpen={isOpen} align="right" className={styles.chevronStyle} />
                <h3 className={`${styles.title} ${styles.gwOverrideDefaultMargin}`}>{title}</h3>
                <div className={styles.row} >
                    <div >
                        <h3 className={`${styles.title1} ${styles.gwOverrideDefaultMargin}`}>{title1}</h3>
                    </div>
                    <div><h3 className={`${styles.title1} ${styles.gwOverrideDefaultMargin}`}>{title2}</h3></div>
                </div>
            </React.Fragment>
        );
    }

    isGeneralCoverage = () => {
        const { policyData } = this.state;
        return (
            [
                'PersonalAuto',
                'BusinessAuto',
                'Homeowners',
                'HOPHomeowners',
                'homeowners',
                'HomeownersLine_HOE',
                'BusinessFleet',
                'BP7BusinessOwners',
                'BusinessOwners',
                'BusinessOwnersLine',
                'BOPLine'
            ].indexOf(policyData.product.productCode) === -1
        );
    };

    hasLiabilityCoverage = () => {
        const { policyData } = this.state;
        return (
            [
                'Homeowners',
                'HOPHomeowners',
                'homeowners',
                'HomeownersLine_HOE',
                'BP7BusinessOwners',
                'BusinessOwners'
            ].indexOf(policyData.product.productCode) >= 0
        );
    };

    getPolicyTransactionStatus = () => {
        return [
            {
                code: 'all',
                name: gatewayMessages.all
            },
            {
                code: 'Draft',
                name: {
                    id: 'typekey.PolicyPeriodStatus.Draft',
                    defaultMessage: 'Draft'
                }
            }
        ];
    };

    handleFilterValueChange = (value) => {
        const { transactionResponse, searchTransactionKeyword } = this.state;
        this.setState({ selectedTransactionStatus: value });
        this.getMappedTransactionData(transactionResponse, {
            selectedTransactionStatus: value,
            searchTransactionKeyword
        });
    };

    handleSearchValueChange = (value) => {
        const { transactionResponse, selectedTransactionStatus } = this.state;
        this.setState({ searchTransactionKeyword: value });
        this.getMappedTransactionData(transactionResponse, {
            searchTransactionKeyword: value,
            selectedTransactionStatus
        });
    };

    

    generateOverrides = () => {
        const { policyData } = this.state;
        const overrides = policyData.coverables.map((coverable, i) => {
            return {
                [`namesGrid${i}`]: {
                    visible: !_.isEmpty(coverable.coverages)
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    getBreakPoint = () => {        
        const breakpointContext = <BreakpointTrackerContext.Consumer />;
        const {
            type: { _currentValue: breakpoint }
        } = breakpointContext;
        return breakpoint
    };    

    updateLiabilityPremium = (premium) => {
        this.setState({liabilityPremium : premium})
    }

    render() {
        const {
            policyData,
            disableCancelLink,
            policyTransactionData,
            policyTransactionStatusValues,
            selectedTransactionStatus,
            searchTransactionKeyword,
            disableChangePolicyLink,
            canAdvanceCancellation,
            canAdvancePolChange,
            policyNamedInsureds
        } = this.state;
        const { authHeader, history, fromAccountLanding, intl } = this.props;
        const policyNumber = _.get(
            fromAccountLanding,
            'policyDetailsData.policyResponse.policyNumber'
        );
        const productCode = _.get(policyData, 'product.productCode');
        if (_.isEmpty(policyData)) {
            return null;
        }
        const translator = this.context;
        const preRenewalDirection = _.get(
            fromAccountLanding,
            'policyDetailsData.policyResponse.latestPeriod.preRenewalDirection'
        );

        // const policyLocationCoverages = useMemo(() => {
        //     const cpLocations = cpData.locations;
        //     console.log("locations: ", cpLocations);
        //     return cpLocations;
        // }, [cpData]);    

        const getCommercialLobData = (cpData) => {
            if(cpData && !_.isEmpty(cpData.locations) ) {
                const cpData1 = _.cloneDeep(cpData);
                cpData1.locations.forEach((location, index) => {
                    cpData.locations[index].dwellingDTO = [];
                    cpData.locations[index].dwellingDTO = location.buildings && !_.isEmpty(location.buildings) ? location.buildings : []  ;
                });
                cpData1.locations.forEach((location, index) => {
                    cpData['dwellingDTO']= cpData['dwellingDTO'] ? cpData['dwellingDTO'] : [];
                    cpData['dwellingDTO'].push(location);
                });
            }
            return cpData
        }        

        const currencyFormatter = Intl.NumberFormat("en-CA", {style: "currency", currency: "CAD"});
        const liabilityTitle2 = `Premium:${ currencyFormatter.format(this.state.liabilityPremium)}`;

        const overrides = {
            summaryPolicyTransactionsTableGrid: {
                data: policyTransactionData
            },
            underlyingPolicyInfo: {
                data: policyData.latestPeriod.underlyingPoliciesEY ? policyData.latestPeriod.underlyingPoliciesEY : [],                
                intl: intl
            },
            underlyingPoliciesContainer: {
                visible: policyData.latestPeriod.underlyingPoliciesEY ? true : false
            },
            summaryPolicyTransactionsId: {
                className: styles.gwTransactionsStyle,
                value: translator(messages.PolicyTransactions)
            },
            coveragesSectionContainer: {
                visible: this.isGeneralCoverage()
            },
            coveragesSection: {
                header: this.getHeaderSection(translator(messages.Coverages))
            },
            liabilityContainer: {
                visible: this.hasLiabilityCoverage()
            },
            liabilityDetailsCardSection: {
                header: this.getLiabilityHeaderSection(translator(messages.LiabilityAndExtensions), '',  liabilityTitle2), //this.getHeaderSection(translator(messages.LiabilityAndExtensions))
            },
            liabilityComponentSection: {
                value: policyData,
                updateLiabilityPremium: this.updateLiabilityPremium
            },
            cancellationContacts: {
                visible: !disableCancelLink && disableChangePolicyLink,
                history,
                authHeader,
                policyNumber: policyNumber,
                policyData: _.get(fromAccountLanding, 'policyDetailsData.policyResponse')
            },
            changePolicyContacts: {
                visible: !disableChangePolicyLink && disableCancelLink,
                history,
                authHeader,
                policyNumber: policyNumber,
                policyData: _.get(fromAccountLanding, 'policyDetailsData.policyResponse')
            },
            changePolicyButtonId: {
                disabled: !disableCancelLink || !disableChangePolicyLink,
                visible: !policyData.latestPeriod.canceled && policyData.latestPeriod.canChange
                && canAdvancePolChange
                && (policyData.product.productCode === 'BusinessAuto' || policyData.product.productCode === 'HOPHomeowners' )
                //|| policyData.product.productCode === 'BP7BusinessOwners' || policyData.product.productCode === 'BusinessOwners')
            },
            renewPolicyButtonId: {
                disabled: !disableCancelLink || !disableChangePolicyLink,
                visible: false
            },
            cancelPolicyButtonId: {
                disabled: !disableCancelLink || !disableChangePolicyLink,
                visible:
                    !policyData.latestPeriod.canceled
                    && policyData.latestPeriod.canCancel
                    && canAdvanceCancellation
                    && (policyData.product.productCode === 'BusinessAuto' || policyData.product.productCode === 'HOPHomeowners' || policyData.product.productCode === 'BP7BusinessOwners' || policyData.product.productCode === 'BusinessOwners')
            },
            policyVehicleInfo: {
                visible: policyData.product.productCode === 'BusinessAuto' || policyData.product.productCode === 'BusinessFleet',
                value: policyData.lobs.businessAuto
            },
            policyHouseOwnersInfo: {
                visible:
                    productCode === 'Homeowners'
                    || productCode === 'HOPHomeowners'
                    || productCode === 'homeowners'
                    || productCode === 'HomeownersLine_HOE'
                    || productCode === 'BP7BusinessOwners',
                value: policyData.lobs.homeOwners
            },
            policyCommercialPropertyInfo: {
                visible:
                    productCode === 'BusinessOwners'
                    || productCode === 'BusinessOwnersLine'
                    || productCode === 'BOPLine'
                    || productCode === 'BP7BusinessOwners',
                //value: getCommercialLobData(policyData.lobs.commercialProperty).locations[0],
                value: policyData.lobs.commercialProperty,
                coverables: policyData.coverables
            },
            policyFarmInfo: {
                visible:
                    productCode === 'BP7BusinessOwners',
                value: policyData.lobs.farm
            },
            policyTransactionStatus: {
                availableValues: policyTransactionStatusValues,
                value: selectedTransactionStatus
            },
            searchFilter: {
                value: searchTransactionKeyword
            },
            preRenewalDirectionValueId: {
                value: !_.isNil(
                    preRenewalDirection
                ) ? [preRenewalDirection]
                    : translator(messages.SummaryDetailsPreRenewalDirectionNone)
            },
            producerOfRecordValueId: {
                value: `${_.get(
                    fromAccountLanding,
                    'policyDetailsData.policyResponse.latestPeriod.producerCodeOfRecordOrg'
                )}(${_.get(
                    fromAccountLanding,
                    'policyDetailsData.policyResponse.latestPeriod.producerCodeOfRecord'
                )})`
            },
            producerOfServiceValueId: {
                value: `${_.get(
                    fromAccountLanding,
                    'policyDetailsData.policyResponse.latestPeriod.producerCodeOfServiceOrg'
                )}(${_.get(
                    fromAccountLanding,
                    'policyDetailsData.policyResponse.latestPeriod.producerCodeOfService'
                )})`
            },
            policyNamedInsuredId: {
                className: styles.gwTransactionsStyle,
                value: translator(messages.policyNamedInsured) 
            },
            summaryPolicyNamedInsuredTableGrid: {
                data: policyNamedInsureds
            },
            ...this.generateOverrides()
        };

        const resolvers = {
            resolveClassNameMap: styles,
            resolveCallbackMap: {
                getCell: getCell,
                getJobNumberLink: this.getJobNumberLink,
                onChangePolicy: this.onChangePolicy,
                onRenewalPolicy: this.onRenewalPolicy,
                handleCancelButtonClick: this.handleCancelButtonClick,
                onDoNotCancel: this.onDoNotCancel,
                handleFilterValueChange: this.handleFilterValueChange,
                handleSearchValueChange: this.handleSearchValueChange,
                onDoNotChangePolicy: this.onDoNotChangePolicy,
                getPremium: getPremium            
            },
            resolveComponentMap: {
                cancelcomponent: Cancellation,
                policypacomponent: PolicyVehiclesDriversInfo,
                changepolicycomponent: ChangePolicy,
                policydwellingcomponent: PolicyDwellingInfo,
                policyfarminfocomponent: PolicyFarmInfoComponent,
                coveragesiterablecomponent: CoveragesIterableComponent,
                coveragescomponent: CoveragesComponent,
                liabilitycomponent: PolicyLiabilityComponent,
                underlyingPoliciesComponent: UnderlyingPolicies,
                policycpinfocomponent: PolicyCommercialPropertyInfoComponent
            }
        };

        const breakpoint = this.getBreakPoint();

        const _metadata = getMetadataByBreakPoint(metadata, breakpoint)

        const readValue = (id, path) => {
            return readViewModelValue(_metadata, policyData, id, path, overrides);
        };
        return (
            <ViewModelForm
                uiProps={_metadata}
                model={policyData}
                overrideProps={overrides}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
                resolveValue={readValue}
            />
        );
    }
}

export const SummaryComponent = Summary;
export default withBreakpoint(withIntl(withAuthenticationContext(Summary)));
